import * as React from "react";
import { RecordFurtherEducationGroupNodes } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNodes";
import { AppUtils } from "source/framework/appUtils";
import * as recordService from "source/models/services/recordService";
import { RecordFurtherEducationTree } from "../RecordFurtherEducationTree";

export interface IRecordFurtherEducationListProp {
    companyId: string;
}

export interface IRecordFurtherEducationListState {
    recordFurtherEducationGroupNodes: RecordFurtherEducationGroupNodes;
}

export class RecordFurtherEducationList extends React.Component<IRecordFurtherEducationListProp, IRecordFurtherEducationListState> {
    constructor(props: IRecordFurtherEducationListProp) {
        super(props);
        this.state = {
            recordFurtherEducationGroupNodes: null
        };
    }
    
    getRecordFurtherEducationGroupNodes = async (): Promise<RecordFurtherEducationGroupNodes> => {
        return AppUtils.callService(() => recordService.getRecordFurtherEducationGroupNodes(this.props.companyId), false);
    };

    componentDidMount(): void {
        this.getRecordFurtherEducationGroupNodes()
            .then(recordFurtherEducationGroupNodes => {
                if (!recordFurtherEducationGroupNodes) return;
                this.setState({ recordFurtherEducationGroupNodes });
            });
    }
    
    render() {
        const props = this.props;
        const state = this.state;
        if (!state.recordFurtherEducationGroupNodes) return null;
        return (
            <RecordFurtherEducationTree
                companyId={props.companyId}
                recordFurtherEducationGroupNodes={state.recordFurtherEducationGroupNodes}
                getRecordFurtherEducationGroupNodes={this.getRecordFurtherEducationGroupNodes}
            />
        );
    }
}